var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tab',[_c('template',{slot:"title"},[_c('div',{staticClass:"tab-sprite",class:_vm.slot_name_assoc[_vm.slot_name]})]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }